import qs from "qs"
import { curatedBaseApi } from "./baseApi";

const collateralLinksPath = "/cip-collateral-links"


const getCollateralLinkAsClientQs = (clientCode) => qs.stringify({
    filters: {
        clientCode: {
            $eq: clientCode
        }
    },
    populate: {
        collateralLinks: {
            fields: ["title", "summary"],
            populate: {
                pdfFile: {
                    fields: ["url", "name"]
                },
                thumbnail: {
                    fields: ["url", "name"]
                }
            }
        }
    },
})


export const collateralLinksApi = curatedBaseApi.injectEndpoints({
    endpoints: build => ({
        getCollateralLinks: build.query({
            query: (clientCode) => {
                return {
                    url: `${collateralLinksPath}?${getCollateralLinkAsClientQs(clientCode)}`
                }
            },
            transformResponse: response => response.data
        })
    })
})


export const { useGetCollateralLinksQuery } = collateralLinksApi